import { render, staticRenderFns } from "./zhilan.vue?vue&type=template&id=32d8e909"
import script from "./zhilan.vue?vue&type=script&lang=js"
export * from "./zhilan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports